module.exports = __webpack_public_path__ + "c692420a2fc3b6fc420031a7c40a52e9.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1039
// module chunks = 0